import { DocumentSortOptionsEnum } from '../types/types';

export const DOCUMENT_SORT_OPTIONS = [
  { label: 'Default Order', value: DocumentSortOptionsEnum.DEFAULT },
  { label: 'Sort Newest To Oldest', value: DocumentSortOptionsEnum.NEWEST },
  { label: 'Sort Oldest To Newest', value: DocumentSortOptionsEnum.OLDEST },
  { label: 'Sort Document A to Z', value: DocumentSortOptionsEnum.ATOZ },
  { label: 'Sort Document Z to A', value: DocumentSortOptionsEnum.ZTOA }
];
// File renamed to src/features/documents/constants/constants.ts
